type LyskraftResponseEnvelope = {
  success?: boolean;
  status?: { type?: string };
};

export const isFailedLyskraftResponse = (value: unknown): boolean => {
  if (!value || typeof value !== 'object') return false;

  const envelope = value as LyskraftResponseEnvelope;
  return envelope.success === false || envelope.status?.type === 'ERROR';
};
